import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';

import FacebookShare from '../Facebook';
import TwitterShare from '../Twitter';
import EmailShare from '../Email';
import Embed from '../Embed';

class ShareGroup extends PureComponent {
    render() {
        return (
            <div className={ `${ style.shareGroup } ${ this.props.className }` } style={ this.props.style }>
                <FacebookShare trackShare={ this.props.trackShare } { ...this.props.facebookProps } />
                <TwitterShare trackShare={ this.props.trackShare } { ...this.props.twitterProps } />
                { this.props.self.usertype &&
                    <EmailShare trackShare={ this.props.trackShare } { ...this.props.emailProps } />
                }
                { this.props.embed &&
                    <Embed trackShare={ this.props.trackShare } list={ this.props.embed } />
                }
            </div>
        );
    }
}
ShareGroup.defaultProps = {
    facebookProps: {},
    twitterProps: {},
    emailProps: {},
    className: '',
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
    };
};

export default connect( mapStateToProps )( ShareGroup );
